import React, { useCallback, useState } from 'react';

import { Grid, TextField } from '@gogame/components';
import { ConfirmDialog } from '@gogame/components';

const ConfirmFinalizedDialog = ({ onSubmit, onExited, onClose, open }) => {
  const [commentText, setCommentText] = useState('');

  const handleChange = useCallback(
    (_e, value) => {
      setCommentText(value);
    },
    [setCommentText]
  );

  const handleSubmit = useCallback(() => {
    onSubmit({ comment: commentText });
  }, [onSubmit, commentText]);

  return (
    <ConfirmDialog
      title={'Finalize Plan?'}
      bodyText={'After the plan finalization it will be available to all users'}
      confirmActionLabel={'Finalize'}
      onSubmit={handleSubmit}
      onExited={onExited}
      onClose={onClose}
      open={open}
    >
      <Grid container direction={'column'}>
        <TextField
          value={commentText}
          onChange={handleChange}
          placeholder={'Comment (optional)'}
          multiline={true}
          rows={2}
        />
      </Grid>
    </ConfirmDialog>
  );
};

export default ConfirmFinalizedDialog;
